let paddingInit = () => {
  const xl = 1200
  const two = 2
  const offset = 15
  const zero = 0
  if (xl <= window.innerWidth) {
    let resize = () => {
      let element = document.querySelector('.header').querySelector('.ug-container').offsetWidth
      element = ((window.innerWidth - element) / two) + offset
      let paddingElementsLeft = document.querySelectorAll('.js-padding-left')
      if (paddingElementsLeft.length > zero) {
        paddingElementsLeft.forEach(el => {
          el.style.paddingLeft = `${element}px`
        })
      }
      let paddingElementsRight = document.querySelectorAll('.js-padding-right')
      if (paddingElementsRight.length > zero) {
        paddingElementsRight.forEach(el => {
          el.style.paddingRight = `${element}px`
        })
      }
    }
    resize()
    window.addEventListener("resize", function () {
      if (xl <= window.innerWidth) {
        resize()
      }
    })
  }
}
export default paddingInit



// WEBPACK FOOTER //
// ./src/js/scripts/paddings.js